import { httpClient } from '@/services/client/http-client'
import type { TUserProfile } from '@/types/auth'

export const __cUserService = {
  getCurrentUser: async (token: string) => {
    if (!token) {
      throw new Error('Token is required')
    }
    const response = await httpClient.V1.get<TUserProfile>(
      `/token/${token}/getUser?ref=2`,
      { headers: { accessToken: token } }
    )
    return response
  },
}
